import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { isNumber } from '@antv/util';
import { Base } from './base';
import { wilkinsonExtended } from '../tick-methods/wilkinson-extended';
import { isValid } from '../utils';
export var Identity = /*#__PURE__*/function (_Base) {
  _inherits(Identity, _Base);
  function Identity() {
    _classCallCheck(this, Identity);
    return _possibleConstructorReturn(this, _getPrototypeOf(Identity).apply(this, arguments));
  }
  _createClass(Identity, [{
    key: "getDefaultOptions",
    /**
     * 返回需要覆盖的默认选项
     * @returns 需要覆盖的默认选项
     */
    value: function getDefaultOptions() {
      return {
        domain: [0, 1],
        range: [0, 1],
        tickCount: 5,
        unknown: undefined,
        tickMethod: wilkinsonExtended
      };
    }
    /**
     * 输入和输出满足：y = x
     * @param x 输入值
     * @returns 输出值
     */
  }, {
    key: "map",
    value: function map(x) {
      return isValid(x) ? x : this.options.unknown;
    }
    /**
     * map 的逆运算：x = y，在这里和 map 是相同方法
     * @param x 输出值
     * @returns 输入值
     */
  }, {
    key: "invert",
    value: function invert(x) {
      return this.map(x);
    }
    /**
     * 克隆 Identity Scale
     * @returns 拥有相同选项且独立的 Identity Scale
     */
  }, {
    key: "clone",
    value: function clone() {
      return new Identity(this.options);
    }
    /**
     * 根据比例尺的配置去生成 ticks，该 ticks 主要用于生成坐标轴
     * @returns 返回一个 ticks 的数组
     */
  }, {
    key: "getTicks",
    value: function getTicks() {
      var _this$options = this.options,
        domain = _this$options.domain,
        tickCount = _this$options.tickCount,
        tickMethod = _this$options.tickMethod;
      var _domain = _slicedToArray(domain, 2),
        min = _domain[0],
        max = _domain[1];
      if (!isNumber(min) || !isNumber(max)) return [];
      return tickMethod(min, max, tickCount);
    }
  }]);
  return Identity;
}(Base);